module.exports = __webpack_public_path__ + "static/media/HR.f60bc302.png";